import React, { useEffect, useState } from 'react';
import '../../styles/components/Tables.scss';

const AUDIT_SEARCH_URL = process.env.REACT_APP_FUNCTION_URL;
const AUDIT_SEARCH_CODE = process.env.REACT_APP_TRAY_AUDIT_SEARCH_CODE;


interface AuditSearchResultProps {
    accessToken: string,
    userName: string,
    userEmail: string
  }

const AuditSearchResult: React.FC<AuditSearchResultProps> = (props : AuditSearchResultProps) => {
    const {
        accessToken,
        userName,
        userEmail
      } = props;

    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${AUDIT_SEARCH_URL}/getUploadHistory?email=${userEmail}`, {
                    method: 'GET',
                    mode: 'cors',
                    headers: {
                      "Content-Type": "application/json",
                      "x-functions-key": `${AUDIT_SEARCH_CODE}`,
                      //"Authorization": `Bearer ${accessToken}`
                    }
                  }) // Replace with your API endpoint
                  .then((response) => {
                    //console.log("Response", response);
                    return response.json();
                })
                setData(response);
                setLoading(false);
            } catch (err) {
                setError('Failed to fetch data');
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            <h1>Audit Search Results</h1>
            <table>
                <thead >
                    <tr>
                        <th>ID</th>
                        <th>Email</th>
                        <th>Storage Line</th>
                        <th>File Name</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => (
                        <tr key={item.Id} >
                            <td>{item.Id}</td>
                            <td>{item.email}</td>
                            <td>{item.storage_link}</td>
                            <td>{item.original_file_name}</td>
                            <td>{item.upload_date}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AuditSearchResult;